export const computeMidPoint = function(ax:number, ay:number, bx:number, by:number){
	return {
		x: (ax + bx) * 0.5,
		y: (ay + by) * 0.5
	};
};